import { useEffect, useState } from "react";
import "../../../styles/panel/user/WithdrawRequests.css";
import { fetchMyWithdrawalRequests } from "../../../api/finance";
import moment from "jalali-moment";
import { convertToPersianDigits } from "../../../utils/stringUtil";

const STATUS_MAP = {
  pending: { label: "در حال بررسی", badge: "pending" },
  done: { label: "انجام شده", badge: "success" },
  canceled: { label: "رد شده", badge: "rejected" },
};

const formatAmount = (n) => n.toLocaleString("fa-IR") + " تومان";

const DocumentIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M16 13H8" />
    <path d="M16 17H8" />
    <path d="M10 9H8" />
  </svg>
);

export default function WithdrawRequests() {
  const [items, setItems] = useState([]);
  const [activeNote, setActiveNote] = useState(null);

  useEffect(() => {
    fetchMyWithdrawalRequests().then((res) => setItems(res.data));
  }, []);

  return (
    <div className="wr-page">
      <div className="wr-header">
        <div>
          <h1>درخواست‌های برداشت</h1>
          <p>لیست درخواست‌های برداشت وجه از کیف پول شما</p>
        </div>
      </div>

      <div className="wr-table-card">
        <div className="wr-table-scroll">
          <table className="wr-table">
            <thead>
              <tr>
                <th>مبلغ</th>
                <th>روش</th>
                <th>مقصد</th>
                <th>تاریخ</th>
                <th>وضعیت</th>
                <th>توضیحات</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td className="wr-empty" colSpan={6}>
                    هنوز درخواست برداشتی ثبت نشده است.
                  </td>
                </tr>
              ) : (
                items.map((r) => {
                  const status = STATUS_MAP[r.status] || {
                    label: r.status,
                    badge: "default",
                  };
                  return (
                    <tr key={r.id}>
                      <td className="wr-amount">{formatAmount(r.amount)}</td>
                      <td>{r.method}</td>
                      <td /*className="wr-destination"*/>
                        {convertToPersianDigits(r.destination)}
                      </td>
                      <td>
                        {convertToPersianDigits(
                          moment(r.created_at).format("jYYYY/jMM/jDD"),
                        )}
                      </td>
                      <td>
                        <span className={`wr-badge wr-badge--${status.badge}`}>
                          {status.label}
                        </span>
                      </td>
                      <td className="wr-desc-cell">
                        {r.admin_note ? (
                          <button
                            type="button"
                            className="wr-note-btn"
                            onClick={() => setActiveNote(r.admin_note)}
                            aria-label="مشاهده توضیحات"
                            title="مشاهده توضیحات"
                          >
                            <DocumentIcon />
                          </button>
                        ) : (
                          <span className="wr-note-empty">—</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {activeNote !== null && (
        <div className="wr-modal-overlay" onClick={() => setActiveNote(null)}>
          <div className="wr-modal" onClick={(e) => e.stopPropagation()}>
            <div className="wr-modal-header">
              <h2>توضیحات ادمین</h2>

              <button
                type="button"
                className="wr-modal-close"
                onClick={() => setActiveNote(null)}
                aria-label="بستن"
              >
                ×
              </button>
            </div>

            <div className="wr-modal-body">
              {activeNote || "توضیحی ثبت نشده است."}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
